// src/components/Layout/Layout.jsx
import React from 'react';
import Footer from './Footer';
import '../../styles/fonts.css'; // Import font styles

const Layout = ({ children }) => {
  return (
    <div className="app-container" style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      backgroundColor: '#121212', // Dark background
      color: '#ffffff' // White text
    }}>
      <main style={{ flex: '1 0 auto' }}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;